module.exports = __webpack_public_path__ + "img/2471.3646c160.jpg";